<template>
  <div class="item col-md-4 flex-column d-flex justify-content-center">
    <b-icon
      :icon="data.ico"
      style="width: 100px; height: 100px;color:var(--primary);margin:5px auto;"
    ></b-icon>
    <h5>{{ data.title }}</h5>
    <p>
      {{ data.description }}
    </p>
  </div>
</template>

<script>
export default {
  name: "itemWelcome",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style></style>
